export default "__VITE_ASSET__MqdFE2sy__"